var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React from 'react';
import { FormControl, FormHelperText, InputLabel, MenuItem, Select, Stack } from '@mui/material';
import { createReactTooltip } from '../../common/tooltip';
import classNames from 'classnames';
import { getVersionBrowserColoringClass } from '../../versionBrowser/utils';
import AccurityIcon from '../../icon/components/AccurityIcon';
export var NULL_VALUE_PLACEHOLDER = 'null';
var UNDEFINED_VALUE_PLACEHOLDER = '';
var emptyOption = {
    value: '',
    label: '',
};
export default (function (_a) {
    var name = _a.name, label = _a.label, value = _a.value, options = _a.options, canBeEmpty = _a.canBeEmpty, className = _a.className, errorMessage = _a.errorMessage, onChange = _a.onChange, optionClassName = _a.optionClassName, disabled = _a.disabled, tooltip = _a.tooltip, coloring = _a.coloring, inherited = _a.inherited;
    var menuOptions = canBeEmpty ? __spreadArray([emptyOption], options, true) : options;
    var _b = createReactTooltip(tooltip, 'enumerationField-' + name), tooltipAnchorParams = _b.tooltipAnchorParams, tooltipElement = _b.tooltipElement;
    var valueToText = function (val) {
        if (val === null) {
            return NULL_VALUE_PLACEHOLDER;
        }
        else if (val === undefined) {
            return UNDEFINED_VALUE_PLACEHOLDER;
        }
        else {
            return String(val);
        }
    };
    var textToValue = function (text) {
        if (text === NULL_VALUE_PLACEHOLDER || text === UNDEFINED_VALUE_PLACEHOLDER) {
            return null;
        }
        else {
            return text;
        }
    };
    return (React.createElement("div", { className: classNames("enumerationField", getVersionBrowserColoringClass(coloring)) },
        React.createElement(Stack, { position: "absolute", right: "0", direction: "row", sx: { zIndex: 3 } }, inherited && React.createElement(AccurityIcon, { iconName: "mui:LayersOutlined", fontSize: "small", color: "secondary700" })),
        React.createElement(FormControl, __assign({ disabled: disabled, fullWidth: true }, tooltipAnchorParams),
            React.createElement(InputLabel, null, label),
            React.createElement(Select, { id: name, label: label, value: valueToText(value), error: !!errorMessage, className: className, onChange: function (event) { return onChange(name, textToValue(event.target.value)); } }, menuOptions.map(function (option) {
                return React.createElement(MenuItem, { key: option.label || valueToText(option.value), className: classNames('enumerationField__option', optionClassName), value: valueToText(option.value) }, option.label || valueToText(option.value));
            })),
            (errorMessage === null || errorMessage === void 0 ? void 0 : errorMessage.trim()) && React.createElement(FormHelperText, null, errorMessage),
            tooltipElement)));
});
//# sourceMappingURL=EnumerationField.js.map